import { call, fetchAllPages } from '../../shared/api.ts'
import type { apiDto } from '@rs/contracts'

/**
 * ══ CỬA GỌI REST CỦA CỔNG THẦU PHỤ (F13) ══════════════════════════════════════════════════════
 *
 * ⚠ KHÔNG cửa nào nhận `vendorId`. Máy chủ lấy nó từ PHIÊN — thầu phụ không được nói mình là ai.
 */
export type MyLegRow = apiDto.VendorLegDto
export type MyPlannedJob = apiDto.VendorPlannedJobDto
export type MyVendorCard = apiDto.VendorMeDto

const BASE = '/api/v1/ncc/legs'

export const fetchMyLegs = (): Promise<MyLegRow[]> => fetchAllPages<MyLegRow>(BASE)

/** `truckPlate` — BKS gõ sẵn, lưu CÙNG lượt nhận chuyến (bản cũ `confirmLeg`); rỗng thì bỏ qua. */
export const confirmMyLegApi = (id: string, version: number, truckPlate = ''): Promise<void> =>
  call<void>(`${BASE}/${id}/confirm`, {
    method: 'POST',
    body: JSON.stringify(truckPlate.trim() === '' ? { version } : { version, truckPlate: truckPlate.trim() }),
  })

export const rejectMyLegApi = (id: string, version: number, reason: string): Promise<void> =>
  call<void>(`${BASE}/${id}/reject`, { method: 'POST', body: JSON.stringify({ version, reason }) })

/** Cont/Seal thầu phụ tự nhập — máy chủ ghi lên ĐƠN của chặng (bản cũ `saveContSeal`). */
export const saveMyContSealApi = (legId: string, contNo: string, sealNo: string): Promise<void> =>
  call<void>(`${BASE}/${legId}/cont-seal`, { method: 'POST', body: JSON.stringify({ contNo, sealNo }) })

/** Thẻ nhận diện thanh tiêu đề: tên · MST · số máy của NCC đang đăng nhập. */
export const fetchMyVendorCard = (): Promise<MyVendorCard> => call<MyVendorCard>('/api/v1/ncc/toi')

/** 📋 Đơn "dự kiến giao cho tôi", CHƯA bắn chặng. */
export const fetchMyPlanned = (): Promise<MyPlannedJob[]> => fetchAllPages<MyPlannedJob>('/api/v1/ncc/du-kien')

/** `bulk` = bấm nút HÀNG LOẠT (câu lịch sử "hàng loạt", `confirmPlanBulk` — `NccPortal.tsx:194-201`). */
export const confirmPlannedApi = (jobIds: readonly string[], bulk: boolean): Promise<{ done: number }> =>
  call<{ done: number }>('/api/v1/ncc/du-kien/xac-nhan', { method: 'POST', body: JSON.stringify({ jobIds, bulk }) })

export const saveMyPlateApi = (id: string, version: number, truckPlate: string): Promise<void> =>
  call<void>(`${BASE}/${id}/bien-so`, { method: 'POST', body: JSON.stringify({ version, truckPlate }) })

/** Ảnh POD chụp ở hiện trường — cùng khuôn base64 với màn nội bộ. */
export const uploadMyPodApi = async (legId: string, file: File): Promise<unknown> => {
  const bytes = new Uint8Array(await file.arrayBuffer())
  let bin = ''
  for (let i = 0; i < bytes.length; i += 32768) {
    bin += String.fromCharCode(...bytes.subarray(i, i + 32768))
  }
  return call<unknown>('/api/v1/ncc/pod', {
    method: 'POST',
    body: JSON.stringify({
      legId, fileName: file.name,
      mime: file.type === '' ? 'application/octet-stream' : file.type,
      dataBase64: btoa(bin),
    }),
  })
}
